import { ChartConfig } from 'components/ui/chart';

import { LegendItemData, ProcessedLegendItem, SplitLegendItems } from './types';

export function extractLegendItemData(
  item: any,
  nameKey: string | undefined,
  config: ChartConfig
): LegendItemData {
  const itemKey = `${nameKey || item.dataKey || '-'}`;
  const itemValue = (item.payload as any)?.[itemKey] || item.value;
  const itemConfig = config[itemValue as string] || config[itemKey];

  return {
    color: item.color,
    label: itemConfig?.label || itemValue,
    icon: itemConfig?.icon
  };
}

export function processLegendItems(
  payload: any[],
  nameKey: string | undefined,
  config: ChartConfig
): ProcessedLegendItem[] {
  return payload.map((item) => ({
    originalItem: item,
    itemData: extractLegendItemData(item, nameKey, config)
  }));
}

export function splitLegendItemsByVisibility(
  processedItems: ProcessedLegendItem[],
  maxVisibleItems: number
): SplitLegendItems {
  const shouldShowMore = processedItems.length > maxVisibleItems;

  const visibleItems = shouldShowMore
    ? processedItems.slice(0, maxVisibleItems - 1)
    : processedItems;

  const hiddenItems = shouldShowMore
    ? processedItems.slice(maxVisibleItems - 1)
    : [];

  return {
    visibleItems,
    hiddenItems,
    shouldShowMore
  };
}
